import { Component, computed, effect, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmRadioGroupImports } from '@spartan-ng/helm/radio-group';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { AlerteComponent } from '@shared/components/alerte/alerte.component';
import { HlmTextareaImports } from '@spartan-ng/helm/textarea';
import { Cartographie } from '../../../cartographie/models/cartographie.model';
import { ModalitéStore } from '../../../modalités/store/modalité.store';
import { LabelRequiredDirective } from '../../../shared/directives/label-required.directive';
import { DetailGeneralFormGroup } from '../séquence-form-form-groups.types';

@Component({
  selector: 'app-detail-general',
  imports: [
    ReactiveFormsModule,
    HlmInputImports,
    HlmFieldImports,
    HlmRadioGroupImports,
    HlmSelectImports,
    BrnSelectImports,
    LabelRequiredDirective,
    AlerteComponent,
    HlmTextareaImports,
  ],
  templateUrl: './detail-general.component.html',
})
export class DetailGeneralComponent {
  readonly #modaliteStore = inject(ModalitéStore);
  readonly form = input.required<DetailGeneralFormGroup>();
  readonly cartographie = input.required<Cartographie>();
  readonly modalites = computed(() => this.#modaliteStore.entities());

  constructor() {
    effect(() => {
      const cartographie = this.cartographie();
      if (cartographie) {
        this.#modaliteStore.charger(cartographie.id);
      }
    });
  }
}
